import React from "react";
import { FrontlineAppConfig } from "oneclick-component/src/store/apis/enhancedApi";

export interface FeatureConfigContextValue extends FrontlineAppConfig {}

export const FeatureConfigContext =
  React.createContext<FeatureConfigContextValue>(null as any);
